import { useState, useEffect } from "react";

export const useStandardCakeFormState = (cakeData = null) => {
  const initialState = {
    name: "",
    displayName: "",
    description: "",
    searchableDescription: "",
    category: "standardCake",
    flavors: [],
    sizes: [],
    colors: [],
    outsideIcing: "",
    isFeatured: false,
    popularity: 0,
    keywords: "",
    seo: {
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
    },
    imageFile: null,
    isVisible: true,
    isAvailable: true,
  };

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cakeData) {
      setFormData({
        ...initialState,
        ...cakeData,
        keywords: Array.isArray(cakeData.keywords)
          ? cakeData.keywords.join(", ")
          : cakeData.keywords || "",
        seo: {
          metaTitle: cakeData.seo?.metaTitle ?? "",
          metaDescription: cakeData.seo?.metaDescription ?? "",
          metaKeywords: Array.isArray(cakeData.seo?.metaKeywords)
            ? cakeData.seo.metaKeywords.join(", ")
            : cakeData.seo?.metaKeywords || "",
        },
        imageFile: null,
        isVisible: cakeData?.isVisible ?? true,
        isAvailable: cakeData?.isAvailable ?? true,
      });
    } else {
      setFormData(initialState);
    }
  }, [cakeData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleKeywordsChange = (e) => {
    setFormData((prev) => ({ ...prev, keywords: e.target.value }));
  };

  const handleSEOChange = (seo) => {
    setFormData((prev) => ({ ...prev, seo }));
  };

  return {
    formData,
    setFormData,
    handleChange,
    handleKeywordsChange,
    handleSEOChange,
    loading,
    setLoading,
  };
};
